import {StyleSheet} from "react-native";
import {styleVars} from "../../../app-style-vars";

export const styles = StyleSheet.create({
  orderContainer: {
    paddingVertical: styleVars.rem(.5),
    borderBottomWidth: 1,
    borderBottomColor: styleVars.boschLightGray,
    zIndex: 1,
  },
  orderHeaderContainer: {
    paddingLeft: styleVars.rem(2.5),
  },
  openIndicator: {
    position: 'absolute',
    top: styleVars.rem(.5),
    left: styleVars.rem(.5),
    width: styleVars.rem(1.5),
    height: styleVars.rem(1.5),
  },
  headerDataContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  headerDataColumn: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflow: 'hidden',
    marginHorizontal: styleVars.rem(.5),
  },
  headerDataColumnMiddle: {
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  headerDataColumnRight: {
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
  headerDataValueText: {
    fontSize: styleVars.rem(.875),
    width: '100%',
  },
  orderNumberText: {
    color: styleVars.boschDarkBlue
  },
  orderDetailsContainer: {
    marginVertical: styleVars.rem(.5),
    paddingLeft: styleVars.rem(2.5),
    paddingRight: styleVars.rem(.5),
  },
  orderDetailsTitle: {
    paddingVertical: styleVars.rem(.5),
  },
  paymentConditionsRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: styleVars.rem(.5),
  },
  paymentConditionsTitle: {
    fontSize: styleVars.rem(.875),
    fontWeight: '600',
  },
  paymentConditionsValue: {
    fontSize: styleVars.rem(.875),
  },
  shipToHeader: {
    paddingVertical: styleVars.rem(.5),
  },
  shipToTitle: {
    fontSize: styleVars.rem(.875),
    fontWeight: '600'
  },
  shipToTitleIcon: {
    fontSize: styleVars.rem(.875),
    paddingRight: styleVars.rem(.5),
  },
  shipToContainer: {
    paddingVertical: styleVars.rem(.5),
  },
  shipToText: {
    fontSize: styleVars.rem(.875)
  },
  orderProductsToggleContainer: {},
  toggleProductsText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue,
  },
  orderProductsContainer: {

  }
});